export const en = {
    'not-found': 'No results found',
    'not-selected': 'Nothing selected',
    'search-placeholder': 'Find segment or experiment',
    title: 'Bid adjustments'
};
